// src/pages/CaseHistoryPage/draftSync.js
/**
 * Pushes offline section drafts to the server when it is reachable again.
 * Same at-least-once idea as the recording sync engine: a local copy is deleted
 * only after the server has confirmed the save.
 */

import { getDrafts, deleteDraft } from './caseHistoryDrafts';
import { saveSection } from './formApi';

/** Try to flush this case's drafts. Returns how many were accepted. */
export async function syncDrafts(caseId) {
  if (!navigator.onLine) return 0;

  const drafts = await getDrafts(caseId);
  let sent = 0;
  for (const draft of drafts) {
    try {
      await saveSection(draft.caseId, draft.sectionKey, draft.answers);
      await deleteDraft(draft.caseId, draft.sectionKey);
      sent += 1;
    } catch (err) {
      // A rejected draft (400) would never succeed, so drop it rather than
      // retrying forever; anything else is probably still the network.
      if (err.response && err.response.status === 400) {
        await deleteDraft(draft.caseId, draft.sectionKey);
      }
      break;
    }
  }
  return sent;
}
